import { getTemplateTemplateScaffoldStyles } from './BodySection.styles'
import type {} from './types/BodySection.type'
import type {} from '../Global/global'

const t = document.createElement('template')
t.innerHTML = `
  <div class="wa-stack">
    <div class="wa-split">
      <slot name="head"></slot>
      <slot name="head-action"></slot>
    </div>
    <slot></slot>
    <div class="wa-split">
      <slot name="foot"></slot>
      <slot name="foot-action"></slot>
    </div>
  </div>
`
const TemplateBodySection = t

class BodySection extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateTemplateScaffoldStyles().content.cloneNode(true))
    shadow.appendChild(TemplateBodySection.content.cloneNode(true))
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('BodySection connectedCallback')
  }
}

if (!customElements.get('ts-body-section')) {
  customElements.define('ts-body-section', BodySection)
}
export { BodySection }
